<template>
  <div v-if="show_body" class="bg-pick">
    <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>

    <div class="info-img pr">
      <img src="@a/ceping76/banner-z1.png"  />
      <span class="ban-text">{{title?title:"'职场可迁移能力报告'"}}</span>
    </div>
    <div class="con-box pr">
      <div class="report-title"></div>
      <!-- 横幅2 -->
      <div class="banner-box">
        <div class="banner pr text-center">
          <div class="p-l pa foam">
            <span class="pa"></span>
            <span class="pa"></span>
            <span class="pa"></span>
          </div>
          <div class="p-r pa foam">
            <span class="pa"></span>
            <span class="pa"></span>
            <span class="pa"></span>
          </div>
          <p>能力优势分析</p>
        </div>
      </div>
      <!-- 第三版块 优劣势分析与建议 -->
      <div class="con-cart">
        <div class="intro-1">
          <p>“能力是我们应对这个变动时代的终极武器，发现并挖掘自身的优势，是我们在职场竞争中脱颖而出的关键。”</p>
          <p>你的能力分布图如下所示。你可以从中发现自己的能力优势，并了解自己能力的整体情况。</p>
          <p class="text-blue text-bold">特别提示：你的优势能力是与自身相比较的，并非与他人相比较的结果。</p>
          
          <div class="charts-box radar-charts-box">
            <ve-radar
              :height="'400px'"
              :data="myRadarChartData1"
              :colors="['rgba(255,255,255,0)', '#ED7D32']"
              :settings="radarConfig"
              :extend="radarExtend"
            ></ve-radar>
          </div>

          <!-- 笑脸 -->
          <div class="circle-box mt34 pr">
            <div class="cart-top-face text-center pa">
              <img src="@a/cart-top-tip.png" alt />
            </div>
            <span>您的相对优势是：</span>
            <span
              class="cir-tag text-bold text-blue"
              v-for="(item,index) in self_top2"
              :key="index"
            >{{item}}</span>
          </div>
          <!--  -->
          <div  class="mt34 pr item-ol">
              <p class="pr" v-for="(item,index) in self_report_top" :key="index">{{item}}</p>
          </div>
        </div>
        </div>
      </div>
      <!--  -->
      <!-- 他评 -->
      <div v-if="data.ta_count>=3">
        <div class="ta-report-title"></div>
        <!-- 横幅2 -->
        <div class="banner-box">
          <div class="banner pr text-center">
            <div class="p-l pa foam">
              <span class="pa"></span>
              <span class="pa"></span>
              <span class="pa"></span>
            </div>
            <div class="p-r pa foam">
              <span class="pa"></span>
              <span class="pa"></span>
              <span class="pa"></span>
            </div>
            <p>他人眼中的我</p>
          </div>
        </div>
        <!--  -->
        <div class="con-box pr"  style="padding-bottom:0;">
          <div class="con-cart on">
            <p>已经有<span>  {{data.ta_count}}  </span>位伙伴，为你做出了客观评价，你的能力优势图如下，希望能带给你更多的启发，并有针对性的扬长避短，强化自己的优势。</p>
            <p class='on'>也可以邀请更多好友继续做评价，让自己的能力优势图更丰富，更有参考意义和价值。</p>
            <!--  -->
            <div class="label-box">
              <table cellspacing="5">
                <thead>
                  <tr>
                    <th>思维能力</th>
                    <th>人际能力</th>
                    <th>任务管理</th>
                    <th>团队管理</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td :class="[getArrIndex('学习领悟') && getArrIndex('学习领悟')<=3?'on':'']">
                      学习领悟
                      <span v-if="getArrIndex('学习领悟')"><br/>-{{getArrIndex('学习领悟')}}-</span>
                    <td :class="[getArrIndex('沟通能力') && getArrIndex('沟通能力')<=3?'on':'']">
                      沟通能力
                      <span v-if="getArrIndex('沟通能力')"><br/>-{{getArrIndex('沟通能力')}}-</span>
                    <td :class="[getArrIndex('高效执行') &&getArrIndex('高效执行')<=3?'on':'']">
                      高效执行
                      <span v-if="getArrIndex('高效执行')"><br/>-{{getArrIndex('高效执行')}}-</span>
                    </td>
                    <td :class="[getArrIndex('发展他人') && getArrIndex('发展他人')<=3?'on':'']">
                      发展他人
                      <span v-if="getArrIndex('发展他人') "><br/>-{{getArrIndex('发展他人')}}-</span>
                    </td>
                  </tr>
                  <tr>
                    <td :class="[getArrIndex('问题解决') && getArrIndex('问题解决')<=3?'on':'']">
                      问题解决
                      <span v-if="getArrIndex('问题解决')"><br/>-{{getArrIndex('问题解决')}}-</span>
                    </td>
                    <td :class="[getArrIndex('团队合作') && getArrIndex('团队合作')<=3?'on':'']">
                      团队合作
                      <span v-if="getArrIndex('团队合作') "><br/>-{{getArrIndex('团队合作')}}-</span>
                    </td>
                    <td :class="[getArrIndex('协调能力') && getArrIndex('协调能力')<=3?'on':'']">
                      协调能力
                      <span v-if="getArrIndex('协调能力')"><br/>-{{getArrIndex('协调能力')}}-</span>
                    </td>
                    <td :class="[getArrIndex('激励他人') && getArrIndex('激励他人')<=3?'on':'']">
                      激励他人
                      <span v-if="getArrIndex('激励他人')"><br/>-{{getArrIndex('激励他人')}}-</span>
                    </td>
                  </tr>
                  <tr>
                    <td :class="[getArrIndex('创新能力') && getArrIndex('创新能力')<=3?'on':'']">
                      创新能力
                      <span v-if="getArrIndex('创新能力')"><br/>-{{getArrIndex('创新能力')}}-</span>
                    </td>
                    <td :class="[getArrIndex('关系管理') && getArrIndex('关系管理')<=3?'on':'']">
                      关系管理
                      <span v-if="getArrIndex('关系管理')"><br/>-{{getArrIndex('关系管理')}}-</span>
                    </td>
                    <td :class="[getArrIndex('计划组织') && getArrIndex('计划组织')<=3?'on':'']">
                      计划组织
                      <span v-if="getArrIndex('计划组织')"><br/>-{{getArrIndex('计划组织')}}-</span>
                    </td>
                    <td :class="[getArrIndex('识人用人') && getArrIndex('识人用人')<=3?'on':'']">
                      识人用人
                      <span v-if="getArrIndex('识人用人')"><br/>-{{getArrIndex('识人用人')}}-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- 横幅3 -->
        <div class="banner-box">
          <div class="banner pr text-center">
            <div class="p-l pa foam">
              <span class="pa"></span>
              <span class="pa"></span>
              <span class="pa"></span>
            </div>
            <div class="p-r pa foam">
              <span class="pa"></span>
              <span class="pa"></span>
              <span class="pa"></span>
            </div>
            <p>他们对你说的话</p>
          </div>
        </div>
        <!--  -->
        <div class="con-box pr"  style="padding-bottom:0;">
          <div class="con-cart on">
            <!--  -->
            <div class="qp-box" v-for="(item,index) in ta_word_list" :key="index">
              <img :src="item.headimgurl?item.headimgurl:'@a/ceping76/qp.png'" />
              <div class="qp-text">
                <h4 class="text-ellipsis">{{item.nickname}}</h4>
                <p>{{item.msg}}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 你的专属海报 -->
        <div class="banner-box">
          <div class="banner pr text-center">
            <div class="p-l pa foam">
              <span class="pa"></span>
              <span class="pa"></span>
              <span class="pa"></span>
            </div>
            <div class="p-r pa foam">
              <span class="pa"></span>
              <span class="pa"></span>
              <span class="pa"></span>
            </div>
            <p>你的专属海报</p>
          </div>
        </div>
        <!--  -->
        <div class="con-box pr"  style="padding-bottom:0;">
          <div class="con-cart on">
            <!--  -->
            <h5 class="poster-text">以下是你的专属“好友眼中的王者”海报，长按分享到朋友圈或群吧！</h5>
            <img  class="poster-img" :src="data.new_poster"  />
          </div>
        </div>
        <!-- 邀请他人反馈 全面了解自我 -->
        <div class="banner-box">
          <div class="banner pr text-center">
            <div class="p-l pa foam">
              <span class="pa"></span>
              <span class="pa"></span>
              <span class="pa"></span>
            </div>
            <div class="p-r pa foam">
              <span class="pa"></span>
              <span class="pa"></span>
              <span class="pa"></span>
            </div>
            <p>邀请他人反馈 全面了解自我</p>
          </div>
        </div>
        <!--  -->
        <div class="con-box pr"  style="padding-bottom:0;">
          <div class="con-cart on">
            <!--  -->
            <h4 class="ta-text"> “以人为镜，可以知得失”，听取别人的反馈有助于从多个视角认识自己的能力，识别自我认知盲区，快去邀请好友给你反馈吧。</h4>
            <h5 class="ta-text on">成功邀请3人以上将获得他评报告，人多越多参考越有参考性~</h5>
          </div>
        </div>
    </div>

    <!--  测评广告-->
    <div class="con-box">
      <!--9.9职业发展进阶广告位  -->
      <div class="career-dev">
        <h4>更多推荐</h4>
        <div class="more-main">
          <img src="@a/ceping76/jyjh.jpg" alt="">
          <div class="more-right">
            <h5>扩散！五大行秋招为应届生提供逾6万个岗位！救业计划全面启动！冲啊！</h5>
            <a href="https://mp.weixin.qq.com/s/0-hCi44vfhI9sbRtKx_9MA">立即查看</a>
          </div>
        </div>
      </div>
    </div>

    <public-ad-qrcode></public-ad-qrcode>
    
    <!-- 邀请他人评价 -->
    <a class="taBtn"  @click="give_share = true">邀请他人给你反馈</a>
    <img class="give_share" alt="分享图片" src="@a/popse.png" v-show="give_share" @click="give_share = false">
    <!-- 自己 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="lock">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号</p>
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt />
        </div>
        <p class="text-yellow text-bold" style="text-align: center;font-size:13px;">可以：查看报告+领取更多测评+获取更多职场加速服务</p>
      </div>
    </van-popup>

  </div>
</template>
<script>
import {
  ceping76_report,
  ceping76_get_ta_word
} from "@/api/measurement";
import { shareCon } from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";

export default {
  data() {
    return {
      title:'',
      data:{},
      past_days: "",
      give_share: false,
      type_obj: {},

      //
      qrcode: "",
      //
      ta_show: false,
      show_body: false,
      lock: false,

      ta_count: 0,

      // 优势劣势-发展
      self_report_top: [],
      // 相对优势
      self_top2: [],
      radarConfig: {
        splitLine: {
          lineStyle: {
            color: ["#F57F17", "rgba(255,255,255, 0)"]
          }
        }
      },
      radarExtend: {
        name: {
          formatter: (text, index) => {
            text = text.replace(/\S{2}/g, function(match) {
              return match + "\n";
            });
            return text;
          }
        }
      },
      // 优劣势分析建议
      myRadarChartData1: {
        columns: [],
        rows: []
      },
      // 他人对我的评价
      ta_label_arr:[],
      ta_word_list:[]
    }
  },
  components:{
    PublicAdQrcode,
    PublicTopTips,
  },
  methods: {
    // 取出当前元素下标
    getArrIndex(val){
      return (this.ta_label_arr.indexOf(val)==-1?0:this.ta_label_arr.indexOf(val))+1
    },

    pullData() {
      this.$toast.loading({
        mask: true,
        message: "加载中..."
      });
      ceping76_report().then(data => {
        // loading
        this.$toast.clear();

        if (data.code !=10002) {
          this.data = data;
          this.title = data.headtitle;
          this.past_days = data.past_days;
          this.type_obj.evaluation_id = data.cid;
          this.type_obj.evaluation_name = data.headtitle;
          this.type_obj.evaluation_user_id = data.uid;
          this.type_obj.nickname = data.nickname;
          this.type_obj.path = this.$route.path;
          shareCon("ceping76", this, this.type_obj);

          this.show_body = true;
          this.qrcode = data.qrcode;
          if (!data.subscribe && data.need_subscribe) {
            this.lock = true;
          }
          if (data.ta_count >= 3) {
            document.title = "就业核心竞争力报告（完整版）";
            ceping76_get_ta_word().then(res=>{
              this.ta_word_list = res.list;
            })
          } else {
            document.title = "就业核心竞争力报告（自评版）";
          }

          //
          this.ta_count = data.ta_count;

          let myRadarChartsColum1 = ["能力"];
          let myRadarChartsRows1 = [{}, {}];
          // myRadarChartsRows1[1] = {
          //   能力: "自评"
          // };
          for (let attr in data.self_analyse_result) {
            myRadarChartsColum1.push(attr);
            myRadarChartsRows1[1][attr] = data.self_analyse_result[attr];
          }
          myRadarChartsRows1[0] = {
            关系管理: 5,
            创新能力: 5,
            协调能力: 5,
            发展他人: 5,
            团队合作: 5,
            学习领悟: 5,
            沟通能力: 5,
            激励他人: 5,
            计划组织: 5,
            识人用人: 5,
            问题解决: 5,
            高效执行: 5
          };
          this.myRadarChartData1 = {
            columns: myRadarChartsColum1,
            rows: myRadarChartsRows1
          };

          // 优势发展
          this.self_report_top = data.self_report_top;

          //
          this.self_top2 = data.self_top2;
          // 他人对我的评价
          this.ta_label_arr = data.ta_count>=3?data.ta_analyse_result_sort:[];
        } else {
          this.$router.push("/ceping76");
        }
      });
    }
  },
  created() {
    this.pullData();
  }
};
</script>
<style lang="scss" scoped>
.taBtn{
  display:block;
  position: fixed;
  left: 50%;
  bottom: 0;
  text-align:center;
  width:100%;
  max-width:750px;
  transform: translateX(-50%);
  line-height:98px;
  background-color:#F46B92;
  font-size:36px;
  color:#ffffff;
  z-index:119;
}
.report-title{
  width: 690px;
  height: 20px;
  margin: 60px 0px 0;
  background-color: #FFFFFF;
  position: relative;
  &::after{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    content: '自评报告';
    font-size: 34px;
    color: #ffffff;
    background-color: #329CD3;
    padding: 0px 12px 5px;
  }
}
.ta-report-title{
  width: 690px;
  height: 20px;
  margin: 60px 30px 0;
  background-color: #FFFFFF;
  position: relative;
  &::after{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    content: '他评报告';
    font-size: 34px;
    color: #ffffff;
    background-color: #329CD3;
    padding: 0px 12px 5px;
  }
}
.bg-pick {
  background: #329CD3;
  padding-bottom:98px;
}
.info-img {
  img {
    width: 100%;
    vertical-align: top;
  }
  .ban-text{
    font-size:60px;
    color:#000000;
    position: absolute;
    display: block;
    top: 142px;
    left: 107px;
    font-weight: bold;
  }
  .poster-tipH {
    font-size: 38px;
    top: 65px;
    left: 30px;
  }
  .poster-tip {
    top: 130px;
    left: 30px;
    font-size: 32px;
  }
}

.mt34 {
  margin-top: 34px;
}

.con-box {
  padding: 0 30px 30px;
  z-index: 1;
  word-wrap: break-word;
}

/* 卡片 */

.cart-top-move {
  transform: translateY(-52px);
  margin-bottom: -52px;
}

.text-yellow {
  color: #f57f17;
}
.text-blue{
  color:#339CD3;
}
.text-bold {
  font-weight: bold;
}

.public-cart {
  .scroll-ico {
    transition: all 0.5s;
    transform: rotateZ(0deg);
    img {
      width: 58px;
      height: 58px;
    }
  }
  .tr {
    transform: rotateZ(180deg);
  }
}

.rgb-cart-box {
  margin-top: 100px;
}

.con-cart {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0px 12px rgba(245, 127, 23, 0.2);
  padding: 52px 0;
  /* 线图box */
  .charts-box {
    margin-top: 50px;
  }
  .loss-100 {
    margin-bottom: -100px;
  }
  .lin-charts-box {
    margin-bottom: -120px;
  }
  .radar-charts-box {
    margin-bottom: -80px;
  }

  /* 标签卡 */
  .circle-box {
    padding: 50px;
    border: 3px solid #339CD3;
    border-radius: 5px;
    .two-title {
      font-size: 28px;
      color: #333;
      font-weight: bold;
    }
    .cir-tag {
      padding: 0 10px;
      padding-bottom: 10px;
      border-bottom: 2px solid #339CD3;
      margin-right: 30px;
    }
    .cart-top-face {
      background: #fff;
      width: 77px;
      height: 53px;
      right: 41px;
      top: -26.5px;
      img {
        width: 53px;
      }
    }
  }

  /*  */
  .item-ol {
    p {
      line-height: 40px;
      margin-top: 14px;
      text-indent: 37px;
    }
    p::after {
      content: "";
      display: block;
      width: 10px;
      height: 10px;
      background: #339CD3;
      border-radius: 5px;
      position: absolute;
      left: 2px;
      top: 15px;
    }
  }
  .intro-1 {
    padding: 0 20px;
    font-size: 26px;
    line-height: 42px;
    color: #333;
    img {
      max-width: 100%;
    }
  }
  .pt34 {
    padding-top: 34px;
  }
  .mt34 {
    margin-top: 34px;
  }
  .title-2 {
    color: #222;
    font-weight: bold;
  }
  .bold-yellow {
    color: #f57f17;
    text-decoration: underline;
  }
  .show-img {
    margin-top: 51px;
    img {
      max-width: 100%;
    }
  }
  /*  */
  .visual {
    margin-top: 30px;
    .line {
      top: 50%;
      height: 0;
      left: 0;
      width: 100%;
      border-top: 2px dashed #339CD3;
    }
    .vis-name {
      font-size: 28px;
      color: #339CD3;
      h4 {
        line-height: 54px;
        position: relative;
        display: inline-block;
        z-index: 1;
        background: #fff;
        padding: 0 10px;
      }
    }
  }
  .cart-footer {
    margin-top: 40px;
    font-size: 28px;
    color: #f57f17;
    font-weight: bold;
    line-height: 42px;
  }
  /* */
  .cart-f-title {
    font-size: 34px;
    font-weight: bold;
  }
  /*  */
  .tag-row {
    color: #f57f17;
    padding: 30px 0 0;
    line-height: 60px;
    span {
      margin-right: 20px;
      font-weight: bold;
      padding: 10px 12px;
      border-bottom: 2px solid #f57f17;
      padding-bottom: 10px;
    }
  }
}
.con-cart.on{
  padding: 60px 20px;
  .ta-text{
    font-size:26px;
    color:#333333;
    line-height:42px;
    margin-bottom:40px;
  }
  .ta-text.on{
    color:#329CD3;
    margin-bottom:0;
  }
  .poster-text{
    font-size:26px;
    color:#329CD3;
    line-height:42px;
    margin-bottom:38px;
  }
  .poster-img{
    width:584px;
    display:block;
    margin:0 auto;
  }
  p{
    font-size: 26px;
    color: #333333;
    line-height: 39px;
    margin-bottom: 25px;
    span{
      color: #329CD3;
    }
  }
  p.on{
    margin-bottom: 0;
  }
  .label-box{
    table{
      width:100%;
      text-align:center;
      thead{
        color:#333333;
        tr th{
          font-size:26px;
          width:150px;
          line-height:1;
          padding:28px 0px 14px;
        }
      }
      tbody{
        color:#ffffff;
        tr td{
          font-size:26px;
          width:150px;
          height:150px;
          background-color: #cccccc;
          line-height:39px;
        }
        tr td.on{
          background-color:#329CD3;
        }
      }
    }
  }
  .qp-box{
    display:flex;
    align-items: center;
    img{
      width:68px;
      height:67px;
      margin-right:25px;
    }
    .qp-text{
      h4{
        font-size:26px;
        font-weight:bold;
        color:#333333;
        margin-bottom:5px;
        width:200px;
      }
      p{
        font-size:26px;
        color:#333333;
        margin-bottom:0;
        width:550px;
        line-height:39px;
      }
    }
  }
}

/* 横幅 */

.banner-box {
  padding: 80px 0 40px;
  .banner-title {
    margin-bottom: 30px;
    span {
      display: inline-block;
      z-index: 1;
      background: #fbf5f0;
      padding: 0 14px;
      font-size: 34px;
      color: #f57f17;
    }
    .ban-header-bg {
      height: 20px;
      width: 100%;
      background: #f57f17;
      left: 0;
      top: 50%;
      margin-top: -10px;
    }
  }
  .banner {
    margin: 0 auto;
    width: 498px;
    height: 62px;
    background: #F46C92;
    border-radius: 31px;
    font-size: 34px;
    color: #fff;
    line-height: 62px;
  }
  .foam {
    top: 0;
    bottom: 0;
    height: 62px;
    width: 0;
    height: 62px;
    span:nth-child(1) {
      width: 16px;
      height: 16px;
      border-radius: 8px;
      background: #FFAEC4;
    }
    span:nth-child(2) {
      width: 20px;
      height: 20px;
      border-radius: 10px;
      background: #F46C92;
    }
    span:nth-child(3) {
      width: 6px;
      height: 6px;
      border-radius: 3px;
      background: #FFAEC4;
    }
  }
  .p-l {
    left: 0;
    span:nth-child(1) {
      top: 27px;
      left: -4px;
    }
    span:nth-child(2) {
      top: 18px;
      left: -18px;
    }
    span:nth-child(3) {
      top: 41px;
      left: -18px;
    }
  }
  .p-r {
    right: 0;
    span:nth-child(1) {
      top: 35px;
      right: -4px;
    }
    span:nth-child(2) {
      top: 44px;
      right: -18px;
    }
    span:nth-child(3) {
      top: 21px;
      right: -18px;
    }
  }
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #f57f17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}

/* 弹窗 */

.explain {
  width: changeRem(13) + px;
  height: auto;
  border-radius: changeRem(0.16) + px;
  background: #fff;
  text-align: center;
  padding: changeRem(0.8) + px changeRem(1.2) + px;
  h2 {
    text-align: justify;
    margin-top: 0;
    font-size: changeRem(0.64) + px;
    color: #eb5032;
    font-weight: normal;
    margin-bottom: changeRem(0.2) + px;
  }
  .pps {
    color: #333;
    font-size: changeRem(0.52) + px;
    line-height: changeRem(0.8) + px;
    text-align: justify;
  }
}

.radius {
  border-radius: 15px;
  text-align: justify;
  .pb-public {
    width: 8rem;
    padding: 40px;
  }
}


.color-animite {
  animation: color-animite 2s infinite;
}

// 9.9职业发展广告
.career-dev {
  background-color: #ffffff;
  margin-top: 20px;
  border-radius:8px;
  padding: 30px;
  h4{
    font-size: 34px;
    color: #333333;
    text-align: left;
    margin-bottom: 30px;
  }
  .more-main {
    box-shadow: 0px 1px 8px 2px rgba(235, 80, 50, 0.14);
    border-radius: 12px;
    padding: 40px;
    display: flex;
    img{
      width: 250px;
      height: 250px;    
    }
    .more-right{
      
      h5{
        font-size: 30px;
        color: #333333;
      }
      a{
        font-size: 32px;
        color: #ffffff;
        background-color: #eb5032;
        border-radius: 32px;
        display: block;
        text-align: center;
        margin-top: 40px;
        line-height: 60px;
        width: 200px;
      }
    }
  }
}
img.give_share {
  width: 100%;
  position: fixed;
  top: 0;
  left: 50%;
  z-index: 1000;
  height: 100%;
  max-width: 750px;
  margin-left: -375px;
}
</style>
<style>
@keyframes color-animite {
  0% {
    color: #339CD3;
  }
  50% {
    color: red;
  }
  100% {
    color: #339CD3;
  }
}

.bg-pick .show-img img {
  max-width: 100%;
  vertical-align: top;
}
</style>
